export default function getUniqueId(prefix: string): string {
    return `${prefix}-${crypto.randomUUID()}`
}
